import { render, staticRenderFns } from "./SlideBarIcon.vue?vue&type=template&id=9e863a6c&"
import script from "./SlideBarIcon.vue?vue&type=script&lang=ts&"
export * from "./SlideBarIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports